import { API_V4_BASE_URL } from './../settings';
import { get } from 'services/api';
import { ICertificate } from 'interface/certificate';
import { toastError } from 'utils/reduxToast';

interface IDataCerticates {
  data: ICertificate[];
}

export const fetchCertificates = (): Promise<IDataCerticates> => {
  const limit = 100;
  const request = get({ url: `/user/certificates?size=${limit}`, baseURL: API_V4_BASE_URL }).catch((error) =>
    toastError('Ops! Não foi possivel listar seus certificados.')
  );
  return request;
};
